<section class="banner">
    <!-- { kenburns-top } this is animation class name  -->
    <div #air id="air" class='air'></div>
    <app-nav class="w-100"></app-nav>
    <app-home-searchbar [ous]="licenseOus"></app-home-searchbar>
</section>

<ng-container *ngIf="!loading">
    <section *ngIf="permissionService.hasPermission('CONTENT','r') || (!isLoggedIn && hasContentDefaultPermisssion())">
        <app-home-entities (licenseOus)="licenseOus = $event"></app-home-entities>
    </section>
</ng-container>

<div class="w-100 d-center" style="height: 100vh;" *ngIf="loading">
    <p-progressSpinner></p-progressSpinner>
</div>

<!-- <section class="home-banner-height">
    <app-home-otherpages></app-home-otherpages>
</section> -->
<p-dialog 
    [blockScroll]="true" [draggable]="false" [closable]="closable && !startQuiz" [modal]="true"
    [header]="announcements && announcements.title"
    [maximizable]="true" [(visible)]="showAnnouncement" (onHide)="setAnnouncementSeenBy(announcements?._id);"
    
    [style]="{ width:'55vw', maxWidth:'1700px',maxHeight:'900px'}">
    <div class="text-center">
        <img *ngIf="announcements && announcements?.image"
            class="img-fluid text-center border border-secondary rounded border-opacity-50 radius-2"
            [style]="{ maxHeight: '400px'}" [src]="staticURL + announcements?.image">
        <p class="annoucementDiv" [innerHTML]="announcements && announcements.description | safeHTML"></p>
    </div>

    <div *ngIf="assessment">
        <div *ngIf="!startQuiz" class="w-100 text-center d-flex flex-row align-items-center justify-center justify-items-center justify-content-center gap-2">
            <p-button class="" label=" {{'Click here to start the exam' | translator}} " [icon]="'pi pi-check'"
                (onClick)="startQuiz=true"></p-button>
            <p-button class="" *ngIf="closable" label=" {{'I will do it later' | translator}} " [icon]="'pi pi-times'"
                (onClick)="showAnnouncement=false"></p-button>
        </div>

        <div *ngIf="startQuiz">

            <app-popupview-questions [(currentQuestion)]="assessment.questions"></app-popupview-questions>
            <p-messages [(value)]="messages" [enableService]="false"></p-messages>
            <div class="w-100 text-center d-flex flex-column align-items-center">
                <p-button class="" label=" {{'Submit Answers' | translator}} " [icon]="'pi pi-checkboxValue'"
                    (onClick)="assessmentSubmit()"></p-button>
            </div>


        </div>

        <div *ngIf="!closable" class="w-100 text-center d-flex flex-column align-items-center">
            <small class="mt-2 alert alert-danger px-4 py-2" role="alert">{{'you have already closed this quiz ' | translator}} {{ignoreCount}}
                {{ 'times. 1' | translator}} {{'You are not allowed to skip this if you have skipped this quiz ' | translator}}
                {{announcements?.ignoreLimit}} {{'times from now' | translator}}.</small>
        </div>
        
        
    </div>

   

</p-dialog>

<app-popup-tutorial [display]="false"></app-popup-tutorial>
<app-footer></app-footer>